export const ZmsFb = "https://www.facebook.com/zmservismoravia/";
